import { combineEpics } from 'redux-observable';
import { analyticsEpic } from './analyticsEpic.js';
import { authenticatedUserEpic } from './authenticatedUserEpic.js';
import { auxiliaryEsimOrderEpic } from './auxiliaryEsimOrderEpic.js';
import { campaignsEpic } from './campaignsEpic.js';
import { catalogsEpic } from './catalogsEpic.js';
import { deviceCheckoutEpic } from './deviceCheckoutEpic.js';
import { employeeOnboardingEpic } from './employeeOnboardingEpic.js';
import { employeeSubscriptionUsageEpic } from './employeeSubscriptionUsageEpic.js';
import { myselfChangesEpic } from './myselfChangesEpic.js';
import { onlineOrdersEpic } from './onlineOrdersEpic.js';
import { paymentsEpic } from './paymentsEpic.js';
import { pickupPointSearchEpic } from './pickupPointSearchEpic.js';
import { punchoutEpic } from './punchoutEpic.js';
import { resourcesEpic } from './resourcesEpic.js';
import { shoppingCartEpic } from './shoppingCartEpic.js';
import { subscriptionActionEpic } from './subscriptionActionEpic.js';
import { supportCaseEpic } from './supportCaseEpic.js';
import type { EpicDependencies } from './epicUtils.js';
import type { ActionTypes } from '../actions/index.js';
import type { State } from '../common/store.js';
import type { Action } from 'redux';
import type { Epic } from 'redux-observable';

export const selfserviceEpic: Epic<ActionTypes, Action, State, EpicDependencies> = combineEpics(
  analyticsEpic,
  auxiliaryEsimOrderEpic,
  campaignsEpic,
  catalogsEpic,
  employeeOnboardingEpic,
  myselfChangesEpic,
  onlineOrdersEpic,
  paymentsEpic,
  pickupPointSearchEpic,
  punchoutEpic,
  shoppingCartEpic,
  subscriptionActionEpic,
  supportCaseEpic
);

export const userEpic: Epic<ActionTypes, Action, State, EpicDependencies> = combineEpics(authenticatedUserEpic);

export const employeeEpic: Epic<ActionTypes, Action, State, EpicDependencies> =
  combineEpics(employeeSubscriptionUsageEpic);

export const deviceCheckoutEpics: Epic<ActionTypes, Action, State, EpicDependencies> = combineEpics(deviceCheckoutEpic);

export { resourcesEpic };

export { paymentsEpic };
